<template>
  <div id="guestproductcontentdownloader-view">
    <GuestProductContentDownloader :orderId="orderId" :oTP="oTP" />
  </div>
</template>

<script lang="ts">
import GuestProductContentDownloader from "@/components/global-components/GuestProductContentDownloader.vue";

export default {
  props: ["orderId", "oTP"],
  components: { GuestProductContentDownloader },
  name: "GuestProductContentDownloaderView",
  data: () => ({}),
};
</script>
